<template>
  <div class="icon-frame" :class="getClassOutline">
    <div class="profile-selector" :class="colorProfile">
      <h4 class="accent font-size-dynamic">{{ initials }}</h4>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps, toValue } from 'vue';

const props = withDefaults(
  defineProps<{
    colorProfile: string;
    initials: string;
    isPartnerPerson?: string | boolean;
  }>(),
  {
    colorProfile: '',
    initials: '',
    isPartnerPerson: false,
  }
);

// 아이콘 태두리 적용 여부
const getClassOutline = computed(() => {
  const isPartner = [true, '1'].includes(props.isPartnerPerson);
  if (isPartner) {
    return 'icon-frame-outline' + ` icon-frame-outline-${toValue(props.colorProfile)}`;
  }
  return '';
});
</script>

<style lang="scss" scoped>
.font-size-dynamic {
  font-size: calc(var(--font-size-h4) * var(--font-multiplier, 1));
}

.profile-selector {
  display: flex;
  width: calc(1.75rem * var(--font-multiplier, 1));
  height: calc(1.75rem * var(--font-multiplier, 1));
  border-radius: calc(50% * var(--font-multiplier, 1));
  justify-content: center;
  align-items: center;
}

.profile-selector.selected {
  outline: 2px solid var(--color-navy-20);
  outline-offset: 1px;
}

.navy {
  background-color: var(--profile-navy-bg);
  border: solid 2px var(--profile-navy-outline);
  color: var(--profile-navy-font);
  :deep(h4) {
    color: inherit;
  }
}

.green {
  background-color: var(--profile-green-bg);
  border: solid 2px var(--profile-green-outline);
  color: var(--profile-green-font);
  :deep(h4) {
    color: inherit;
  }
}

.yellow {
  background-color: var(--profile-yellow-bg);
  border: solid 2px var(--profile-yellow-outline);
  color: var(--profile-yellow-font);

  :deep(h4) {
    color: inherit;
  }
}

.pink {
  background-color: var(--profile-pink-bg);
  border: solid 2px var(--profile-pink-outline);
  color: var(--profile-pink-font);
  :deep(h4) {
    color: inherit;
  }
}

.purple {
  background-color: var(--profile-purple-bg);
  border: solid 2px var(--profile-purple-outline);
  color: var(--profile-purple-font);
  :deep(h4) {
    color: inherit;
  }
}

.icon-frame {
  display: flex;
  justify-content: center;
  align-items: center;

  width: calc(1.75rem * var(--font-multiplier, 1));
  max-width: calc(1.75rem * var(--font-multiplier, 1));
  height: calc(1.75rem * var(--font-multiplier, 1));
  border-radius: calc(16px * var(--font-multiplier, 1));

  position: relative;
}

.icon-frame-outline {
  outline-offset: 1px;
}

.icon-frame-outline-navy {
  outline: 2px solid var(--profile-navy-outline);
}

.icon-frame-outline-yellow {
  outline: 2px solid var(--profile-yellow-outline);
}

.icon-frame-outline-pink {
  outline: 2px solid var(--profile-pink-outline);
}

.icon-frame-outline-purple {
  outline: 2px solid var(--profile-purple-outline);
}

.icon-frame-outline-green {
  outline: 2px solid var(--profile-green-outline);
}
</style>
